import React from 'react';
import { useLanguage } from '../providers/LanguageProvider';

const Bullet = () => {
  const { isRTL } = useLanguage();
  
  return (
    <span className="px-2 text-mocha">
      {isRTL ? '◂' : '▸'}
    </span>
  );
};

export default Bullet;